import React, { Component } from "react";

import Dialog from "material-ui/Dialog";
import LoginForm from "components/Auth/LoginForm";
import ResetForm from "components/Auth/ResetForm";
import RegistrationForm from "components/Auth/RegistrationForm";
const style = {
  login: {},
  overlay: {
    background: "none"
  }
};

export default class Login extends Component {
  state = { form: 'login' };

  showLogin = e => {
    e.preventDefault();
    this.setState({ form: 'login' });
  };

  showRegister = e => {
    e.preventDefault();
    this.setState({ form: 'register' });
  };

  showReset = e => {
    e.preventDefault();
    this.setState({ form: 'reset' });
  };

  render() {
    return (
      <div className="login">
        <div className="login__box">
          <img className="login__box__komm" alt="" src="/images/komm.png" />
          <div className="login__box__logo">
            <img alt="" src="/images/onestop-logo-svv-225x150.png" />
          </div>
          {this.state.form === 'register' &&
            <RegistrationForm>
              <a onClick={this.showLogin}>
                Har du redan ett konto, logga in?
              </a>
            </RegistrationForm>
          }
          {this.state.form === 'login' &&             
              <LoginForm >                          
              <a onClick={this.showRegister}>
                Skapa ett konto?
              </a>
              <a onClick={this.showReset}>
                Glömt ditt lösenord?
              </a>
            </LoginForm>            
          }
          {this.state.form === 'reset' &&             
              <ResetForm >                          
              <a onClick={this.showLogin}>
              Kan du ditt lösenord? Logga in.
              </a>
            </ResetForm>            
          }
        </div>
        <p className="login__footer">
          <span>Version: {process.env.REACT_APP_VERSION}</span>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/Login.jsx